<script setup lang="ts">
const props = defineProps<{
  data: any
  payType: number
}>()
const style = computed(() => {
  switch (props.data.resource) {
    case 3:
      return {
        background: 'linear-gradient(180deg, #FFF -5.63%, #F1F6FF 75.8%)',
        color: '#0564F1',
        subColor: '#A6BFFF',
      }
    case 2:
      return {
        background: 'linear-gradient(158deg, #FFF 7.51%, #F9F5FF 68.37%)',
        color: '#5E42AF',
        subColor: '#AC98E9',
      }
    case 1:
      return {
        background: 'linear-gradient(170deg, #FFF 10.46%, #F4F4FF 90.4%)',
        color: '#2A2B2D',
        subColor: '#B9B9B9',
      }
    default:
      return {
        background: 'linear-gradient(180deg, #FFF -5.63%, #F1F6FF 75.8%)',
        color: '#4295FF',
        subColor: '#A6BFFF',
      }
  }
})
const curPrivilege = computed(() => {
  return props.data?.privileges?.find((item: Api.User.Privilege) => item.month === props.payType)
})
const { open } = useVipModal()
const { isSubAccount } = useLogin()
</script>

<template>
  <div relative box-border flex flex-col items-center rd-8 bg-white px-20 py-16 :style="style">
    <div flex items-center gap-12>
      <div flex items-baseline gap-60 :class="{ 'mt-14 mb-4': data.resource === 3 }">
        <h1 text-20 font-600 class="my-0 ellipsis">
          {{ $t(data.label) }}
        </h1>
        <div v-if="data.resource === 3" text-12 font-600 ellipsis>
          {{ $t('免费') }}
        </div>
        <div v-else class="flex items-baseline gap-4">
          <span class="text-12 font-600">{{ $t('vip.低至') }}</span>
          <span class="text-36 font-dinpro600"><span text-stroke-1.5>￥</span><span ml--6>{{ curPrivilege?.realPrice }}</span></span>
          <span class="text-12 font-600">/{{ payType === 1 ? $t('月') : $t('年') }}</span>
        </div>
      </div>
    </div>
    <p class="my-20 text-10" :style="{ color: style.subColor }">
      {{ $t(data.dec) }}
    </p>
    <UserVipBtn :disabled="isSubAccount" :data="data" :payType="payType" :isSmall="true" class="absolute bottom--24 left-0" @click="open(payType, data.resource)" />
  </div>
</template>

<style lang="less" scoped>

</style>
